import LeftIcon from "~/images/leftIcon.svg?react";
import RightIcon from "~/images/rightIcon.svg?react";

export function Pagination({
  totalCount,
  limit,
  currentPage,
  onChangePage,
}: {
  totalCount: number;
  limit: number;
  currentPage: number;
  onChangePage: (page: number) => void;
}) {
  const totalPage = Math.ceil(totalCount / limit);
  const maxPageButtons = 5; // 表示するページボタンの最大数
  const halfMaxButtons = Math.floor(maxPageButtons / 2);

  // 表示するページ番号の範囲を計算
  let startPage = Math.max(1, currentPage - halfMaxButtons);
  const endPage = Math.min(totalPage, startPage + maxPageButtons - 1);

  // 表示範囲が最大ページ数に満たない場合の調整
  if (endPage - startPage + 1 < maxPageButtons) {
    startPage = Math.max(1, endPage - maxPageButtons + 1);
  }

  const pages = [...Array(endPage - startPage + 1)].map((_, i) => startPage + i);

  return (
    <div className="flex justify-start items-center gap-2 mb-3">
      <button
        onClick={() => (currentPage !== 1 ? onChangePage(currentPage - 1) : null)}
        disabled={currentPage === 1}
        aria-label="Previous page"
        className="border-none bg-transparent p-0"
      >
        <div
          className={`w-8 h-8 rounded-[4px] border border-solid border-[#4AB2DE] text-[#1A8FC1] flex items-center justify-center text-center ${currentPage !== 1 ? "cursor-pointer" : "cursor-not-allowed"}`}
        >
          <LeftIcon className="w-4 h-4" />
        </div>
      </button>
      {startPage > 1 && (
        <>
          <button
            onClick={() => onChangePage(1)}
            aria-label="Go to page 1"
            className="border-none bg-transparent p-0"
          >
            <div className="w-8 h-8 rounded-[4px] border border-solid border-[#4AB2DE] text-[#1A8FC1] flex items-center justify-center text-center cursor-pointer">
              1
            </div>
          </button>
          {startPage > 2 && <span className="text-[#1A8FC1]">...</span>}
        </>
      )}
      {pages.map((i) => {
        return i === currentPage ? (
          <div
            key={i}
            className="w-8 h-8 bg-[#1D9FD6] flex items-center justify-center text-center text-white rounded"
          >
            {i}
          </div>
        ) : (
          <button
            onClick={() => onChangePage(i)}
            key={i}
            aria-label={`Go to page ${i}`}
            className="border-none bg-transparent p-0"
          >
            <div className="w-8 h-8 rounded-[4px] border border-solid border-[#4AB2DE] text-[#1A8FC1] flex items-center justify-center text-center cursor-pointer">
              {i}
            </div>
          </button>
        );
      })}
      {endPage < totalPage && (
        <>
          {endPage < totalPage - 1 && <span className="text-[#1A8FC1]">...</span>}
          <button
            onClick={() => onChangePage(totalPage)}
            aria-label={`Go to page ${totalPage}`}
            className="border-none bg-transparent p-0"
          >
            <div className="w-8 h-8 rounded-[4px] border border-solid border-[#4AB2DE] text-[#1A8FC1] flex items-center justify-center text-center cursor-pointer">
              {totalPage}
            </div>
          </button>
        </>
      )}
      <button
        onClick={() => (currentPage * limit >= totalCount ? null : onChangePage(currentPage + 1))}
        disabled={currentPage * limit >= totalCount}
        aria-label="Next page"
        className="border-none bg-transparent p-0"
      >
        <div
          className={`w-8 h-8 rounded-[4px] border border-solid border-[#4AB2DE] text-[#1A8FC1] flex items-center justify-center text-center ${currentPage * limit >= totalCount ? "cursor-not-allowed" : "cursor-pointer"}`}
        >
          <RightIcon className="w-4 h-4" />
        </div>
      </button>
      <div className="flex items-center justify-center text-sm gap-3 ml-6">
        <div>{totalCount}件中</div>
        <div>
          {limit * (currentPage - 1) + 1}-{Math.min(limit * currentPage, totalCount)}件
        </div>
      </div>
    </div>
  );
}
